<script type="text/javascript">
    // 定义一些公共的属性和方法
    const httpUrl = 'http://39.105.17.99:8080/';
    const bgurl='https://api.xianpipa.com/images/template/head/tou1.jpg';
    const baseImgUrl= 'https://api.xianpipa.com';
    function commonFun() {
    }
    // 暴露出这些属性和方法
    export default {
        httpUrl,
        bgurl,
        baseImgUrl,
        commonFun
    }
</script>


// WEBPACK FOOTER //
// src/global/global.vue